function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E36D54",
  fillRule: "evenodd",
  d: "M3.25 13A9.75 9.75 0 0 0 13 22.75 9.75 9.75 0 0 0 22.75 13 9.75 9.75 0 0 0 13 3.25 9.75 9.75 0 0 0 3.25 13Zm1.36 0A8.389 8.389 0 0 1 13 4.61 8.389 8.389 0 0 1 21.39 13 8.389 8.389 0 0 1 13 21.39 8.389 8.389 0 0 1 4.61 13Zm7.71 4.308h1.814v-5.442H12.32v5.442Zm0-7.256h1.814V8.238H12.32v1.814Z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M3.25 13A9.75 9.75 0 0 0 13 22.75 9.75 9.75 0 0 0 22.75 13 9.75 9.75 0 0 0 13 3.25 9.75 9.75 0 0 0 3.25 13Zm1.36 0A8.389 8.389 0 0 1 13 4.61 8.389 8.389 0 0 1 21.39 13 8.389 8.389 0 0 1 13 21.39 8.389 8.389 0 0 1 4.61 13Zm7.71 4.308h1.814v-5.442H12.32v5.442Zm0-7.256h1.814V8.238H12.32v1.814Z",
  clipRule: "evenodd"
});

var SvgIcnErrorHeader = function SvgIcnErrorHeader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 20,
    height: 20,
    x: 3,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ref3));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnErrorHeader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-error-header.ec690ef1.svg";
export { ForwardRef as ReactComponent };